import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, ViewController } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { KlmrTimesheetCreatePage } from '../klmr-timesheet-create/klmr-timesheet-create';
import { SearchPage } from '../search/search';


@IonicPage()
@Component({
  selector: 'page-klmr-timesheet-create-add',
  templateUrl: 'klmr-timesheet-create-add.html',
})
export class KlmrTimesheetCreateAddPage {
  createTimeSheet: FormGroup;
  selectOptions: any;
  jobNumber: any = "Select Job No";
  jobDescription: any = "";
  activityCode: any = "Select";
  timeDifference: any;
  jobNumberList: any = [];
  list: any = [];
  actiivityCodeList: any = [];
  isUpdate: boolean = false;
  params: any = {};
  timeLoop: any;
  isCopy: boolean = false;
  jobCardData: boolean = false;
  actionAllowed:boolean = false;

  disabled:boolean = false;
  isApproval:boolean = false;

  errorButton:boolean = true;
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider, private formBuilder: FormBuilder, private modalController: ModalController, private viewController: ViewController) {
    this.selectOptions = {
      mode: 'ios'
    };
    this.params = this.navParams.get('param');
    this.isCopy = this.navParams.get('copy');
    const jobData = this.navParams.get('jobData');
    const approval = this.navParams.get('approval');
    if(approval){
      this.isApproval = true;
    }
    console.log("isCopy", this.isCopy);
    console.log("jobData", jobData);
    console.log("this.params", this.params);
    
    let currentDate = new Date();
     var d = new Date();
  let aeest = d.toLocaleString( "en-US", { timeZone: "Australia/Sydney"});
  let year = d.toLocaleString( "default", { year: "numeric" ,timeZone: "Australia/Sydney"});
  let month = d.toLocaleString( "default", { month: "2-digit" ,timeZone: "Australia/Sydney"});
  let day = d.toLocaleString( "default", { day: "2-digit" ,timeZone: "Australia/Sydney"});
  var date = year + "-" + month + "-" + day;;
    this.createTimeSheet = this.formBuilder.group({
      date: new FormControl(date, [Validators.required]),
      job_no: new FormControl('', [Validators.required]),
      activity_code: new FormControl(''),
      job_description: new FormControl('', [Validators.required]),
      start_time: new FormControl('', [Validators.required]),
      finish_time: new FormControl('', [Validators.required]),
      // activity_type: new FormControl('', [Validators.required]),
      notes: new FormControl(''),
      user_id: new FormControl(''),
      smoko: new FormControl(false),
      lunch: new FormControl(false),
      // meal: new FormControl(false),
    });
      if (this.params) {
        this.isUpdate = true;

        if(this.params.isDisabled){
          this.disabled = true
        }

      }else{
        var today = new Date().toLocaleTimeString();
        this.createTimeSheet.get(`start_time`).setValue(today);

        console.log(today);
      }
    if (jobData) {
      this.createTimeSheet.patchValue({ ...jobData });
        this.jobNumber = jobData.job_no;
         this.getJobDescription(this.jobNumber);
      this.jobCardData = true;
    }

  }

  ionViewDidLoad() {
    this.getPermission();

    this.getMetaData();
    this.timeLoop = setInterval(() => {
      var elements = document.getElementsByClassName("select-text");
      // console.log(elements.length,'-',elements);
      if (elements.length > 0) {
        if (elements[0].innerHTML.length != 0) {
          elements[0].innerHTML = elements[0].innerHTML.split("/")[0];
        }
      }
    }, 500);

  }
  ionViewDidLeave() {
    clearInterval(this.timeLoop);
  }


  async getMetaData() {
    let userId = await this.utiltiy.getStorage("userId");
    if (userId) {
      this.createTimeSheet.get(`user_id`).setValue(userId);
    }
    this.list = await this.getJobNumberList();
    this.actiivityCodeList = await this.getActivityCodeList();
    if (this.params) {
      if (userId) {
        this.params.user_id = userId;
      }
      this.regenerateForm();
    }
  }

  async getJobNumberList() {
    this.jobNumberList = [];
    this.utiltiy.startLoading();
    return this.api.get("/prestart/job_no/Job_no_get?folder_name=1", false)
      .then((result: any) => {
        console.log("result", result);
        this.utiltiy.stopLoading();
        if (result.status) {
          result.result.forEach(element => {
            element.key = element.id,
            element.value = element.job_no +"/"+element.job_description
           
          });
          return result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      });
  }

  async getActivityCodeList() {
    this.actiivityCodeList = [];
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name","activity_code");
    return this.api.post("/prestart/Activity_code", false,formData)
      .then((result: any) => {
        console.log("result", result);
        this.utiltiy.stopLoading();
        if (result.status) {
          result.result.forEach(element => {
            element.key = element.id,
            element.value = element.code +"/"+element.description
           
          });
          
          return result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      });
  }

  regenerateForm() {
    this.createTimeSheet.patchValue({
      date:  this.isCopy ? "":this.params.date,
      job_no: this.params.job_no,
      activity_code: this.params.activity_code,
      job_description: this.params.job_description,
      start_time:  this.isCopy ? "": this.params.start_time,
      finish_time:  this.isCopy ? "": this.params.finish_time,
      // activity_type: this.params.activity_type,
      notes: this.params.notes,
      user_id: this.params.user_id,
      smoko:   this.isCopy ? false: this.params.smoko == "false" ? false : true,
      lunch:  this.isCopy ? false: this.params.lunch == "false" ? false : true,
      meal:  this.isCopy ? false: this.params.meal == "false" ? false : true,

    });
    this.getJobDescription(this.params.job_no);
    this.getActiveeCode(this.params.activity_code);
    this.jobNumber = this.params.job_no;
    // this.activityCode = this.params.activity_code;
    this.timeChanged();
  }

  getJobDescription(job_no) {
    let index = this.list.findIndex(list_ => list_.job_no.toLowerCase() == job_no.toLowerCase());

    if (index != -1) {
      this.jobDescription = this.list[index].job_description;
    }

  }
  getActiveeCode(job_no) {
    let index = this.actiivityCodeList.findIndex(list_ => list_.id == job_no);

    if (index != -1) {
      this.activityCode = this.actiivityCodeList[index].code;
    }

  }

  verifyEvent(){
    if (this.createTimeSheet.value.finish_time && this.createTimeSheet.value.start_time) {

    }
  }

  async timeChanged() {
    // this.ampmToHours("01:00 PM")
    console.log(this.createTimeSheet.value.finish_time, "time is", this.createTimeSheet.value.start_time);
    if (this.createTimeSheet.value.finish_time && this.createTimeSheet.value.start_time) {
      this.verifyTime();
      this.timeDifference = await this.calculateTimeDifference(this.createTimeSheet.value.start_time, this.createTimeSheet.value.finish_time);
      // if (this.createTimeSheet.value.activity_type.length > 0) {
      // this.timeDifference = await this.deductMinutes(this.timeDifference, 5)
      // }
    }
  }


  calculateTimeDifference(startTime, endTime) {
    var start = startTime.split(":");
    var end = endTime.split(":");
    var startDate = new Date(0, 0, 0, start[0], start[1], 0);
    var endDate = new Date(0, 0, 0, end[0], end[1], 0);
    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);

    if (hours < 0)
      hours = hours + 24;
    return (hours <= 9 ? "0" : "") + hours + ":" + (minutes <= 9 ? "0" : "") + minutes;
  }

  async deductMinutes(time, difference) {
    var minutesToAdd = difference;
    var currentDate = new Date();
    currentDate.setHours(parseInt(time.split(":")[0]), parseInt(time.split(":")[1]), 0, 0);
    var futureDate = new Date(currentDate.getTime() - minutesToAdd * 60000);
    return (futureDate.getHours() <= 9 ? "0" : "") + futureDate.getHours() + ":" + (futureDate.getMinutes() <= 9 ? "0" : "") + futureDate.getMinutes();
  }


  formatAMPM(date) {
    var hours = date[0];
    var minutes = date[1];
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = date[0] + ':' + date[1];
    return strTime;
  }

  ampmToHours(time) {
    var hours = Number(time.match(/^(\d+)/)[1]);
    var minutes = Number(time.match(/:(\d+)/)[1]);
    var AMPM = time.match(/\s(.*)$/)[1];
    if (AMPM === "PM" && hours < 12) hours = hours + 12;
    if (AMPM === "AM" && hours === 12) hours = hours - 12;
    var sHours = hours.toString();
    var sMinutes = minutes.toString();
    if (hours < 10) sHours = "0" + sHours;
    if (minutes < 10) sMinutes = "0" + sMinutes;
    console.log("--", (sHours + ":" + sMinutes));
    return (sHours + ":" + sMinutes);
  }

  add(item) {
    this.jobNumberList = [];
    this.jobNumber = item.job_no;
    this.createTimeSheet.get(`job_no`).setValue(item.job_no);
    this.createTimeSheet.get(`job_description`).setValue(item.job_description);

  }

  removeFocus() {
    console.log("ii");
    this.jobNumberList = [];
  }

  search() {
    // this.jobNumber = this.createTimeSheet.value.job_no;
    if (!this.jobNumber.trim().length) {
      this.jobNumberList = [];
      return;
    }

    this.jobNumberList = this.list.filter(item => item.job_no.toUpperCase().includes(this.jobNumber.toUpperCase()));
  }

  async onOpenCommonModal() {


  }


  async manupilateList() {
    let manupilatedList = [];
    this.jobNumberList.forEach(element => {
      manupilatedList.push({ 'key': element.job_no, 'value': element.job_no });
    });
    return manupilatedList;
  }





  dropDownChange(value, key) {
    // this.createTimeSheet.get(`${key}`).setValue(value);
    this.createTimeSheet.get(`job_no`).setValue(value);
    this.jobNumber = value;
    // this.createTimeSheet.get(`job_description`).setValue(value.job_description);
    let index = this.list.findIndex(list_ => list_.job_no.toLowerCase() == value.toLowerCase());
    if (index != -1) {
      this.createTimeSheet.get(`job_description`).setValue(this.list[index].job_description);
    }
  }


  submit() {
    let formKeys = Object.keys(this.createTimeSheet.value);
    if (this.isCopy) {

      let formData: FormData = new FormData();
      formKeys.forEach(key => {
        if (key == "smoko" || key == "lunch" || key == "meal") {
          var value = this.createTimeSheet.value[key] == false ? "false" : "true";
          formData.append(key, value);
        } else {
          formData.append(key, this.createTimeSheet.value[key]);
        }
      });
      this.addTimeSheet(formData);
    } else {

      if (this.isUpdate) {
        let string = "";
        formKeys.forEach(key => {
          if (string.length == 0) {
            string = string + "" + key + "=" + this.createTimeSheet.value[key];
          } else {
            if (key == "smoko" || key == "lunch" || key == "meal") {
              var value = this.createTimeSheet.value[key] == false ? "false" : "true";
              string = string + "&" + key + "=" + value;
            } else {
              string = string + "&" + key + "=" + this.createTimeSheet.value[key];
            }
          }
        });
        let body = string;
        console.log("string-1", body);
        this.updateTimeSheet(body, this.params.id);
      } else {

        let formData: FormData = new FormData();
        formKeys.forEach(key => {
          formData.append(key, this.createTimeSheet.value[key]);
        });
        this.addTimeSheet(formData);
      }
    }
    console.log("this.credentialsForm.value", this.createTimeSheet.value);


  }

  addTimeSheet(formData) {
    this.api.post(`/prestart/timesheet/store`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          if (this.jobCardData) {
            this.viewController.dismiss();
            // return;
          }
          this.navCtrl.setRoot(KlmrTimesheetCreatePage);
        }

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }


  updateTimeSheet(formData, id) {
    this.api.put(`/prestart/timesheet/update/${id}`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.navCtrl.setRoot(KlmrTimesheetCreatePage);
        }

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }
  // Rest and luch do not work the same as web timesheets deducting time
	// Comments  DONE
	// 	API :-http://192.168.0.104/klmr_cabsand/klmr-web/index.php/api/prestart/timesheet/timesheet_store/checkTimeSheetPeriodAvailable
	// 		Parameters
	// 			date:2022-08-03
	// 			start_time:13:33:00
	// 			finish_time:12:33:00
	// 			lunch:true
	// 			smoko:true
	// 			meal:false
	// 			edit_id: 0 
  // https://hub-qa.klmrcivil.com.au/index.php/api/prestart/timesheet/timesheet_checkperiod
  // /prestart/timesheet/timesheet_store/checkTimeSheetPeriodAvailable
  verifyTimeData(formData) {
    this.utiltiy.startLoading();
    this.api.post(`/prestart/timesheet/timesheet_checkperiod`, false, formData)
      .then((result: any) => {
        console.log("result", result);
        this.utiltiy.stopLoading();
        if (result.error) {
          this.utiltiy.toaster(result.error);
          this.errorButton = false;
          // this.createTimeSheet.get(`finish_time`).setValue("");
          // this.timeDifference = null;

        }else{
          this.errorButton = true;

        }

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }

  async openModal( ){
    if(this.disabled){
      return;
    }
    const profileModal = this.modalController.create(SearchPage, { data: {list : this.list,header:"Job Number List"}},{ cssClass: 'managers',enableBackdropDismiss:true});
    profileModal.onDidDismiss(data => {
      console.log(data);
      if(data){
        this.jobNumber = data.job_no;
        this.getJobDescription(this.jobNumber);
        this.dropDownChange(data.job_no,'job_no');
      }
    });
    profileModal.present();

  }
  
  async openCommonModal(list, title, key, value, model, formkey) {
    if(this.disabled){
      return;
    }
    list = await this.createData(list, key, value);
    console.log("list", list)
    const profileModal = this.modalController.create(SearchPage, { data: {list: list, header: title}},{ cssClass: 'managers',enableBackdropDismiss:true});
    profileModal.onDidDismiss(data => {
      console.log(data);
      if(data){
        this.createTimeSheet.get(formkey).setValue(data.key);
        this[model] = data.value;
      }
    });
    profileModal.present();

  }

  async createData(list, key, value) {
    list.forEach(element => {
      element.key = element[key];
      element.value = element[value];
    });

    return list;
  }

  

  

  async getPermission(){
    this.actionAllowed =  await this.utiltiy.getPagePermission("klmr-timesheet-create-rw");
    console.log("actionAllowed",this.actionAllowed)
   }

   verifyTime(){
     if(this.createTimeSheet.value.finish_time && this.createTimeSheet.value.start_time){

       let formData: FormData = new FormData();
       formData.append('date', this.createTimeSheet.value.date);
       formData.append('start_time', this.createTimeSheet.value.start_time);
       formData.append('finish_time', this.createTimeSheet.value.finish_time);
       formData.append('lunch', this.createTimeSheet.value.lunch);
       formData.append('smoko', this.createTimeSheet.value.smoko);
       formData.append('meal', "false");
       formData.append('edit_id', "0");
       this.verifyTimeData(formData);
     }
   
    console.log("verifyTime")
   }

}




// WEBPACK FOOTER //
// ./src/pages/klmr-timesheet-create-add/klmr-timesheet-create-add.ts